import React from 'react';
import { connect } from 'react-redux';

function HRFooter(props) {

  var phoneResult = props.user_phone.substr(0, 3) + " " + props.user_phone.substr(3, 3) + " " + props.user_phone.substr(6, 3);
    return (
    <>
      <div id="divtocopy">
          <table cellPadding="0" width="520" style={{verticalAlign: "-webkit-baseline-middle"}}>
              <tr>
                <td>
                  <table width="100%">
                    <tr>
                      <td style={{width:"180px", textAlign:"left"}}>
                        <table cellPadding="0" width="180">
                            <tr>
                              <td width="180">
                                <img style={{verticalAlign:"middle",borderRadius:'6px'}} src={props.user_image} alt="avatar" width="135"/>
                              </td>
                            </tr>
                        </table>
                      </td>
                      <td style={{color:"rgb(0, 0, 0)",verticalAlign:"top"}}>
                        <table>
                          <tr>
                            <td>
                              <h1 style={{fontFamily:"Arial",margin:"0", fontWeight:"400",fontSize:"28px"}}>
                                {props.user_name}
                                <span style={{fontSize:"28px",fontFamily:"Arial",fontWeight:"700"}}>
                                  &nbsp;{props.user_surname}
                                </span>
                              </h1>
                              <h4 style={{fontFamily:"Arial",fontWeight:"normal",margin:"0",fontSize:"14px",color:"#fd5600"}}>
                                {props.user_position}
                              </h4>
                            </td>
                          </tr>
                          <tr>
                            <td height='35'></td>
                          </tr>
                          <tr>
                            <td width="350">
                              <table>
                                <tr>
                                  <td>
                                      {!props.user_phone ? (
                                      <span></span>
                                    ) : (
                                      <>
                                      <img style={{verticalAlign:"bottom",width:"17px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/o-phone.png" alt=""/>
                                      &nbsp;<span style={{fontFamily:"Arial",lineHeight:"16px",fontWeight:"400",fontSize:"14px",display:"inline-block"}}>
                                        +48 {phoneResult}
                                      </span>
                                      </>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <img style={{verticalAlign:"middle", width:"17px"}} src="https://columbusenergy.pl/lp/stopka/generator/assets/o-mail.png" alt=""/>
                                    &nbsp;<span style={{fontFamily:"Arial",margin:"0",lineHeight:"16px",fontWeight:"400",fontSize:"14px",display:"inline-block",color:"#000"}}>
                                        {props.user_email}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr style={{height:"25px",verticalAlign:"middle"}}>
                  <td>
                    <hr size="1" color="#DFEAF3"></hr>
                  </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tr>
                      <td style={{width:"185px"}}>
                        <table style={{borderSpacing: "0"}}>
                          <tr>
                            <td>
                              <img src="https://stopka.columbusenergy.pl/assets/logomain.png" alt="" style={{verticalAlign:"middle",width:"40px"}}/>
                            </td>
                            <td width="180" style={{lineHeight:"13px",fontSize:"10px",fontFamily:"Arial",color:"rgb(0, 0, 0)",fontWeight:"400",padding:"0 0 0 20px"}}>
                              <span style={{color:"#000",fontSize:"10px",fontWeight:"700",verticalAlign: "middle"}}>
                                Columbus Energy S.A.
                              </span>
                              <br />ul. Pana Tadeusza 4
                              <br />30-727 Kraków
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <table style={{borderSpacing: "0"}}>
                          <tr>
                            <td style={{width:"180px",lineHeight:"13px",fontSize:"10px",fontFamily: "Arial",color:"rgb(0, 0, 0)",fontWeight:"400",padding:"0"}}>
                              NIP: 949-216-31-54
                              <br/><span style={{fontFamily: "Arial",color:"#000",fontSize:"10px",fontWeight:"400"}}>biuro@columbusenergy.pl</span>
                              <br/>tel. 12 307 30 96
                            </td>
                          </tr>
                        </table>
                      </td>
                      <td>
                        <table width='150' style={{borderSpacing:"0"}}>
                            <tr>
                              <td width='12' align="right"style={{textAlign:"right"}}>
                                  <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.linkedin.com/company/columbusenergy">
                                    <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/o-in.png" alt=""/>
                                  </a>
                              </td>
                              <td width='12' align="right" style={{textAlign:"right"}}>
                                  <a style={{display:"inline-block",textDecoration:"none"}} href="https://www.youtube.com/channel/UCpk-ain20Of43QA-_GDTI8g">
                                    <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/o-yt.png" alt=""/>
                                  </a>
                              </td>
                              <td width='12' align="right" style={{textAlign:"right"}}>
                              <a style={{display:"inline-block", textDecoration: "none"}} href="https://pl-pl.facebook.com/columbusenergysa">
                                    <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/o-fb.png" alt=""/>
                                  </a>
                              </td>
                              <td width='12' align="right" style={{textAlign:"right"}}>
                              <a style={{display:"inline-block", textDecoration:"none"}} href="https://columbusenergy.pl/">
                                    <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/o-web.png" alt=""/>
                                  </a>
                              </td>
                              <td width='12' align="right" style={{textAlign:"right"}}>
                              <a style={{textDecoration: "none"}} href="https://www.instagram.com/columbusenergy/">
                                    <img width='20' src="https://columbusenergy.pl/lp/stopka/generator/assets/o-inst.png" alt=""/>
                                  </a>
                              </td>
                            </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr style={{height:"25px",verticalAlign:"middle"}}>
                  <td>
                    <hr size="1" color="#DFEAF3"></hr>
                  </td>
              </tr>
              <tr>
                <td>
                  <table>
                    <tr>
                      <td style={{width:"340px",fontFamily: "Arial",fontSize:"10px",lineHeight: "13px",fontWeight: "400",color: "#787878"}}>
                        Columbus Energy S.A. uhonorowany certyfikatem Przyjazna Rekrutacja
                        <br />oraz nagrodą Friendly Workplace 2022.
                      </td>
                      <td>
                        <img width='170' src="https://columbusenergy.pl/lp/stopka/generator/assets/logos.png" alt=""/>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
          </table>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    user_name: state.user_reducer.user_name,
    user_surname: state.user_reducer.user_surname,
    user_position: state.user_reducer.user_position,
    user_email: state.user_reducer.user_email,
    user_phone: state.user_reducer.user_phone,
    user_image: state.user_reducer.user_image,
  }
}
export default connect(mapStateToProps)(HRFooter);